import {
  fieldStateClass,
  fieldMessageClass,
} from "@src/utility_functions/fieldClasses";
export const PublishStatusSelectInput = (props) => {
  return (
    <div className="two_column_gutter_2">
      <label htmlFor={props.inputID}>
        Publish Status
        <select
          defaultValue={props.publishStatus}
          id={props.inputID}
          name="publishStatus"
          required={true}
          className={
            props.validationResponse &&
            fieldStateClass(props.validationResponse.errorClass)
          }
          onChange={props.changeHandler}
        >
          <option value="published" className="select_option_prompt">
            Published
          </option>
          <option value="private" className="select_option_prompt">
            Private
          </option>
        </select>
      </label>
      {props.validationResponse &&
        props.validationResponse.errorClass !== "valid" && (
          <div
            className={fieldMessageClass(props.validationResponse.errorClass)}
          >
            {props.validationResponse.errorMessage}
          </div>
        )}
    </div>
  );
};
